import { render } from "./CookieModal.vue?vue&type=template&id=1ca7328d&scoped=true"
import script from "./CookieModal.vue?vue&type=script&lang=js"
export * from "./CookieModal.vue?vue&type=script&lang=js"

import "./CookieModal.vue?vue&type=style&index=0&id=1ca7328d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca7328d"]])

export default __exports__